var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SettingsPanelComponent } from '../settings-panel.component';
import { finalize } from 'rxjs/operators';
var CacheSettingsComponent = /** @class */ (function (_super) {
    __extends(CacheSettingsComponent, _super);
    function CacheSettingsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CacheSettingsComponent.prototype.clearCache = function () {
        var _this = this;
        this.loading = true;
        this.artisan.call({ command: 'cache:clear' })
            .pipe(finalize(function () { return _this.loading = false; }))
            .subscribe(function () {
            _this.toast.open('Cache cleared.');
        });
    };
    return CacheSettingsComponent;
}(SettingsPanelComponent));
export { CacheSettingsComponent };
